<!--
  Copyright (c) MobiFactory. All rights reserved.
  This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
  See LICENSE.txt file in the project root for full license information.
-->

<template>
  <el-select v-model="selectedPotentialId" :placeholder="$t('AccountCreation.PotentialPlaceholder')">
    <el-option
      v-for="potential in accountPotentials"
      :key="potential.id"
      :value="potential.id"
      :label="potentialLabel(potential)"
    >
    </el-option>
  </el-select>
</template>

<script>
import accountsApi from "../../api/account/accountsApi";
import { defineComponent } from "vue";

export default defineComponent({
  name: "CrmAccountPotentialSelect",

  props: {
    modelValue: {
      type: String,
      default: null,
    },
  },
  emits: ["update:modelValue"],
  /**
   * Gets the component data
   * @returns {object} Component data
   */
  data() {
    return {
      accountReferenceData: null,
    };
  },
  computed: {
    /**
     * Gets the sorted potentials.
     * @returns {Array} The potentials.
     */
    accountPotentials() {
      let selection = this.accountReferenceData?.accountPotentials?.filter((rd) => !rd.isDeleted);
      if (selection && !selection.find((rd) => rd.id === this.modelValue)) {
        const deletedSelection = this.accountReferenceData.accountPotentials.find((rd) => rd.id === this.modelValue);
        if (deletedSelection) {
          selection.push(deletedSelection);
        }
      }

      return selection?.sort((a, b) => b.index - a.index);
    },

    selectedPotentialId: {
      /**
       * Gets the potential id
       * @returns {string}
       */
      get() {
        return this.modelValue;
      },

      /**
       * On option selected
       * @param {string} value - selected potential id
       */
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },

  /**
   * When component is created
   */
  async created() {
    await this.loadAccountReferenceData();
  },

  methods: {
    /**
     * Gets the potential label.
     * @param {object} potential - The account potential.
     * @returns {string} The label.
     */
    potentialLabel(potential) {
      return `P${potential.index} : ${potential.label} - ${potential.amount.toLocaleString()} €`;
    },

    /**
     * Loads the account reference data
     * @return {Promise<void>}
     */
    async loadAccountReferenceData() {
      const refDataResult = await accountsApi.getReferenceData();
      if (refDataResult.isSuccess) {
        this.accountReferenceData = refDataResult.data;
      }
    },
  },
});
</script>

<style scoped lang="scss"></style>
